import axios from "axios";
axios.defaults.headers["Access-Key" ] = process.env.VUE_APP_ACCESS_KEY

export const getFeaturedProgram = (params = {}) => {
  return axios.get("/program/v1/company/public/list", { params });
};

export default { getFeaturedProgram };
